var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 7.074a1.5 1.5 0 0 1-1.096-.475C8.931 4.488 7.052 4.235 5.86 4.702c-1.2.47-2.36 1.921-2.36 4.615 0 1.359.754 2.945 2.058 4.609 1.275 1.626 2.92 3.129 4.349 4.288C11.36 19.393 11.595 19.5 12 19.5s.64-.107 2.093-1.286c1.429-1.16 3.074-2.662 4.35-4.288 1.303-1.664 2.057-3.25 2.057-4.609 0-2.694-1.16-4.146-2.36-4.615-1.192-.467-3.07-.214-5.044 1.897A1.5 1.5 0 0 1 12 7.074Zm-1.058-2.489c.357.288.71.617 1.058.99.348-.373.701-.702 1.058-.99C17.317 1.145 22 3.569 22 9.317c0 3.73-4.02 7.674-6.962 10.062C13.706 20.459 13.04 21 12 21c-1.04 0-1.706-.54-3.038-1.621C6.019 16.99 2 13.047 2 9.317c0-5.748 4.683-8.173 8.942-4.732Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.5 6.25a.75.75 0 0 1 .75.75v1.25h1.25a.75.75 0 0 1 0 1.5h-1.25V11a.75.75 0 0 1-1.5 0V9.75H14.5a.75.75 0 0 1 0-1.5h1.25V7a.75.75 0 0 1 .75-.75Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.806a3d8702ca00356121e0cc7bc4c944.svg";
export { ForwardRef as ReactComponent };